import { render, staticRenderFns } from "./CapacitationsComponent.vue?vue&type=template&id=63ccf8c1&"
import script from "./CapacitationsComponent.vue?vue&type=script&lang=js&"
export * from "./CapacitationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports